/**
 * The New chat dialog's Add people state, pure TypeScript. No React, no DOM,
 * no SDK: a fan the search matched, and the small set already added to the
 * draft. Kept separate from `NewChatDialog.tsx` so the add/remove/dedupe
 * rules are testable without rendering anything (ISSUE-760).
 */

export type typeChatMemberCandidate = {
  userId: string;
  username: string;
  displayName: string;
  avatarUrl: string | null;
};

export type typeAddPeopleRowAction = "add" | "added";

export function resolveAddPeopleRowAction(
  candidate: typeChatMemberCandidate,
  alreadySelected: readonly typeChatMemberCandidate[],
): typeAddPeopleRowAction {
  return alreadySelected.some((member) => member.userId === candidate.userId)
    ? "added"
    : "add";
}

/**
 * Appends a candidate to the selection, unless they are already in it. The
 * search itself never returns the viewer or a fan already selected still
 * showing "add" (the row already reads "added" by then), so this stays a
 * plain dedupe rather than a defensive no-op path.
 */
export function addSelectedMember(
  current: readonly typeChatMemberCandidate[],
  candidate: typeChatMemberCandidate,
): typeChatMemberCandidate[] {
  if (current.some((member) => member.userId === candidate.userId)) {
    return [...current];
  }
  return [...current, candidate];
}

export function removeSelectedMember(
  current: readonly typeChatMemberCandidate[],
  userId: string,
): typeChatMemberCandidate[] {
  return current.filter((member) => member.userId !== userId);
}
